export default {
  width: 16,
  height: 18,
  svg: `
    <g fill-rule="nonzero">
      <path d="M10.4019 8.23872L2.74957 0.457121L12.4858 6.12542L10.4019 8.23872ZM0.752405 0C0.301655 0.239109 0 0.675132 0 1.24126V16.7587C0 17.3249 0.301655 17.7609 0.752405 18L9.64951 8.99824L0.752405 0ZM15.4954 7.9328L13.4531 6.73374L11.1751 9.00176L13.4531 11.2698L15.537 10.0707C16.1611 9.56788 16.1611 8.43563 15.4954 7.9328ZM2.74957 17.5464L12.4858 11.8781L10.4019 9.7648L2.74957 17.5464Z"/>
    </g>
  `
}
